<template>
  <div
    :class="`content-section ${classes} ${no_margin ? '' : 'content-section--with-panel'} ${no_content_padding ? 'content-section--without-content-padding' : ''}`"
    compact
  >
    <div
      v-if="title"
      :class="{
        'content-section__header': true,
        'content-section__header--without-content-padding': no_content_padding,
      }"
    >
      <vb-icon v-if="icon" :name="icon" :size="20" />
      <span class="content-section__title" v-html="title"></span>
    </div>
    <p
      v-if="description"
      :class="{
        'content-section__description': true,
        'content-section__description--without-content-padding':
          no_content_padding,
      }"
      v-html="description"
    ></p>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'content-section',
    props: {
      icon: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      description: {
        type: String,
        default: '',
      },
      classes: {
        type: String,
        default: '',
      },
      no_margin: {
        type: Boolean,
        default: false,
      },
      no_content_padding: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .content-section {
    margin-bottom: 1rem !important;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    &--with-panel {
      background-color: $white;
      padding: $grid-gutter-width / 2;
      border-radius: $border-radius-lg * 2;
    }
    &--without-content-padding {
      padding: 0px !important;
    }

    &__header {
      display: flex;
      gap: 10px;
      align-items: center;
      &--without-content-padding {
        padding: $grid-gutter-width / 2 $grid-gutter-width / 2 0
          $grid-gutter-width / 2;
      }
    }
    &__title {
      font-weight: $vb-font-weight-semibold;
      @include media-breakpoint-down(md) {
        font-size: 20px;
      }
    }
    &__description {
      @include media-breakpoint-down(md) {
        font-size: 14px;
      }
      &--without-content-padding {
        padding: 0 $grid-gutter-width / 2;
      }
    }
  }
</style>
